import * as React from "react";
import { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "../fonts/Lexend-VariableFont_wght.ttf";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import { Fragment } from "react";
import { Stack } from "@mui/system";
import Button from "@mui/material/Button";
import TableSortLabel from "@mui/material/TableSortLabel";
// import { teamArray } from "../Data/team";
import { fullTeamArray } from "../Data/fullTeamArray";

const tableSortLabelStyle = {
	"&.MuiTableSortLabel-root": {
		color: "white",
	},
	"&.MuiTableSortLabel-root:hover": {
		color: "white",
	},
	"&.Mui-active": {
		color: "white",
	},
	"& .MuiTableSortLabel-icon": {
		color: "white !important",
	},
};





export function TeamListItem({
  timeData,
  fullTeamArray,
  sortCriteria,
  sortOrder,
}) {
  const sortedArray = [...fullTeamArray].sort((a, b) => {
    if (!sortCriteria) return 0;
    if (sortOrder === "asc") {
      return a[sortCriteria].localeCompare(b[sortCriteria]);
    } else {
      return b[sortCriteria].localeCompare(a[sortCriteria]);
    }
  });

  const danielIndex = sortedArray.findIndex((person) => person.name === "Daniel Dobrzensky");
  if (danielIndex !== -1) {
    const danielPerson = sortedArray.splice(danielIndex, 1)[0];
    sortedArray.unshift(danielPerson);
  }

  const personList = sortedArray.map((person) => {
    const timezoneData = timeData.find((data) => data.timezone === person.timezone);

    return (
      <Fragment key={person.id}>
        <Grid 
					id={`${person.name}`+ `-item`} container xs={12}
					justifyContent="space-between" 

				className="parent-grid-container" py={1} px={2}>
					<Grid xs={6} md={4}
						// md={3} 
						display="flex" alignItems="center" my={2}>
						<Stack direction="row" alignItems="center" spacing={1}>

							<Avatar
								sx={{ border: "1px solid white" }}
								src={`${person.imgUrl}`}
								alt={`${person.name}`}
							/>


							<Typography variant="listItemHead" textAlign="left">
								{person.name}
							</Typography>

						</Stack>
					</Grid>


					<Grid
						// xs={3}
						md={3}
						display={{ xs: "none", md: "flex" }}
						alignItems="center"
						justifyContent="left"

					>
						<Stack>
							<Typography variant="semibold" textAlign="left">
								{person.role}
							</Typography>
							<Typography
								color={`rgba(255, 255, 255, 0.7)`}
								fontWeight={300}
								variant="body1"
								textAlign="left">
								{person.team}
							</Typography>

						</Stack>


					</Grid>



					<Grid
						xs={2}
						md={2}
						display={{ xs: "none", md: "flex" }}
						alignItems="center"
						justifyContent="left"

					>
						<Typography
							color={`rgba(255, 255, 255, 0.7)`}
							fontWeight={300}
							variant="body1"
							textAlign="left">
							{person.location}
						</Typography>
					</Grid>
					<Grid
						xs={6}
						md={3}

						display="flex"
						flexDirection="column"
						justifyContent="center">
						<Stack direction="row" justifyContent="flex-end">
							{timezoneData ? (
								<>
									<Typography
										color="#4caf50"
										fontWeight={400}
										textAlign="right"
										mr={1}>
										{new Intl.DateTimeFormat("en-US", {
											timeZone: timezoneData.timezone,
											hour: "2-digit",
											minute: "2-digit",
										}).format(new Date(timezoneData.datetime))}
									</Typography>

									<Typography
										color={`rgba(255, 255, 255, 0.9)`}
										fontWeight={300}
										textAlign="right">
										{timezoneData.abbreviation}
									</Typography>
								</>
							) : (
								<Typography textAlign="right">
									0:00 {timezoneData.abbreviation}
								</Typography>
							)}
						</Stack>

						<Typography
							color={`rgba(255, 255, 255, 0.7)`}
							fontWeight={300}
							variant="bodySubTitle"
							sx={{ textTransform: "uppercase" }}
							textAlign="right">
							{(() => {
								const difference =
									parseInt(timezoneData.utc_offset) -
									parseInt(timeData[5].utc_offset);

								if (isNaN(difference)) {
									return null;
								}

								const text =
									difference >= 0
										? `${difference} hours ahead`
										: `${Math.abs(difference)} hours behind`;
								return text;
							})()}
						</Typography>
					</Grid>

					<Divider
						light={true}
						sx={{ borderColor: "rgb(50 57 74 / 80%)", width: "100%" }}
					/>
				</Grid>
      </Fragment>
    );
  });

  return <>{personList}</>;
}





function TeamList({
	time,
	timeArray,
	timeData,
}) {
	const [sortCriteria, setSortCriteria] = useState("name");
	const [sortOrder, setSortOrder] = useState("asc");

	const handleSort = (criteria) => {
		if (criteria === sortCriteria) {
			setSortOrder(sortOrder === "asc" ? "desc" : "asc");
		} else {
			setSortCriteria(criteria);
			setSortOrder("asc");
		}
	};

	return (
		<>
			<Grid container m={0} px={2} xs="true" justifyContent="flex-start">
				<Grid xs={12} display="flex" alignItems="center" my={2}>
					<Typography sx={{ fontWeight: 600 }} variant="h5">
						Your team
					</Typography>
				</Grid>



				<Grid
					xs={6}
					md={4}
					// display={{ xs: "none", md: "flex" }}
					alignItems="center"
					justifyContent="left"

				>
					<Button
						sx={{ padding: "0", color: "white" }}
						onClick={() => handleSort("name")}>
						Name
						<TableSortLabel
							active={sortCriteria === "name"}
							direction={sortOrder}
							sx={tableSortLabelStyle}
						/>
					</Button>
				</Grid>

				<Grid
					xs={1}
					md={3}
					display={{ xs: "none", md: "flex" }}
					alignItems="center"
					justifyContent="left"

				>
					<Button
						sx={{ padding: "0", color: "white" }}
						onClick={() => handleSort("role")}>
						Role
						<TableSortLabel
							active={sortCriteria === "role"}
							hideSortIcon={false}
							direction={sortOrder}
							sx={tableSortLabelStyle}
						/>
					</Button>
				</Grid>

				<Grid
					xs={1}
					md={2}
					display={{ xs: "none", md: "flex" }}
					alignItems="flex-start"
					justifyContent="left"

				>
					<Button
						sx={{ padding: "0", color: "white" }}
						onClick={() => handleSort("location")}>
						Location
						<TableSortLabel
							active={sortCriteria === "location"}
							hideSortIcon={false}
							direction={sortOrder}
							sx={tableSortLabelStyle}
						/>
					</Button>
				</Grid>

				<Grid
					xs={6}
					md={3}
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="flex-end"
					textAlign="left">
					<Typography
						sx={{ textTransform: "uppercase" }}
						variant="subtitle2"
					>
						Timezone
					</Typography>
				</Grid>
				<Divider
					light={true}
					sx={{ borderColor: "rgb(50 57 74 / 80%)", width: "100%", mt: 2 }}
				/>
			</Grid>
			{localStorage.getItem("fullName") && (
				<TeamListItem
					time={time}
					timeArray={timeArray}
					timeData={timeData}
					// teamArray={teamArray}
					fullTeamArray={fullTeamArray}
					sortCriteria={sortCriteria}
					sortOrder={sortOrder}
				/>
			)}
		</>
	);
}

export default TeamList;
